define(
    '../core/Sound.js',[
        'config',
        'loader'
    ],
    function(Config, Loader)
    {
        var Modernizr = Loader.Modernizr;
        var $ = Loader.$;

        var _play = function(soundType, volume)
        {
            (typeof volume == 'undefined') && (volume = 1);

            var audio = document.getElementById(soundType);
            if (!audio) {
                _load(soundType, volume);
                return;
            }
            audio.pause();
            audio.volume && (audio.volume = volume);
            audio.currentTime && (audio.currentTime = 0);
            audio.play();
        };

        var _stop = function(soundType)
        {
            var audio = document.getElementById(soundType);
            if(!audio) return;
            audio.pause();
            audio.currentTime && (audio.currentTime = 0);
        };

        var _load = function(soundType, volume) {
            if (Config.sounds.indexOf(soundType) == -1) return;
            var soundLibHTML = '';
            var type = Modernizr.audio.ogg ? 'ogg' :
                Modernizr.audio.mp3 ? 'mp3': false;

            if (type) {
                soundLibHTML += '<audio id="' + soundType + '" src="//' + cloudHost + '/s1/client/sounds/' + type + '/' + soundType + '.' + type + '?' + productVersion + '" preload></audio>';
                $('body').append(soundLibHTML);
            }
            _play(soundType, volume);
        };

        return {
            play: _play,
            stop: _stop
        };
    }
);

